module.exports = __webpack_public_path__ + "static/img/axcess.72ce57e.png";